import { render, staticRenderFns } from "./BookEntriesDeferred.vue?vue&type=template&id=4313617d&scoped=true&"
import script from "./BookEntriesDeferred.vue?vue&type=script&lang=js&"
export * from "./BookEntriesDeferred.vue?vue&type=script&lang=js&"
import style0 from "./BookEntriesDeferred.vue?vue&type=style&index=0&id=4313617d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4313617d",
  null
  
)

export default component.exports